import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1000;
`;

export const SwitchButton = styled.button`
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  border-radius: 18px;
  padding: 6px 8px;
  font-size: 0;
  line-height: 1;
  letter-spacing: 0.5px;
  backdrop-filter: blur(6px);

  &:hover {
    background: rgba(0, 0, 0, 0.55);
  }

  &:focus {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }
`;

export const Menu = styled.ul`
  position: absolute;
  top: 44px;
  right: 0;
  margin: 0;
  padding: 6px;
  list-style: none;
  min-width: 120px;
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(8px);
`;

export const MenuItem = styled.li`
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;

  &[aria-checked='true']::after {
    content: ' ✓';
    opacity: 0.9;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }
`;
